import { Button, Popconfirm, Row, Space, Table, Typography } from 'antd';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';
import Title from 'antd/lib/typography/Title';
import styled from 'styled-components';

import { styledTable } from '../styled/mixin';
import { Task, TaskStatus, taskStatusKorean } from '../../modules/tasks';
import { User } from '../../modules/auth';

interface TaskListComponentProps {
  tasks: Task[];
  user: User;
  moveToDetailPage: (taskId: string) => void;
  moveToCreatePage: () => void;
  onDelete: (taskId: string) => void;
}

const StyledDiv = styled.div`
  ${styledTable}
`;

function TaskListComponent({
  tasks,
  user,
  moveToCreatePage,
  moveToDetailPage,
  onDelete,
}: TaskListComponentProps) {
  const columns: ColumnsType<Task> = [
    {
      title: '제목',
      width: '10%',
      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <span
            className="clickable-table-item"
            onClick={() => moveToDetailPage('' + record.id)}
          >
            <Typography.Paragraph
              ellipsis={{ rows: 1 }}
              style={{ margin: '0px' }}
            >
              {`${record.name}`}
            </Typography.Paragraph>
          </span>
        </>
      ),
    },
    {
      title: '내용',
      width: '20%',
      ellipsis: true,
      render: (text: any, record: any, index: any) => (
        <Typography.Paragraph ellipsis={{ rows: 1 }} style={{ margin: '0px' }}>
          {`${record.description ?? ''}`}
        </Typography.Paragraph>
      ),
    },
    {
      title: '상태',
      width: '5%',
      render: (text: any, record: any) => (
        <>{taskStatusKorean[record.status as keyof typeof taskStatusKorean]}</>
      ),
    },
    {
      title: '요청자',
      ellipsis: true,
      width: '5%',
      render: (text: any, record: any) => <>{record.requester.name}</>,
    },
    {
      title: '담당자',
      ellipsis: true,
      width: '5%',
      render: (text: any, record: any) => <>{record.assignee.name}</>,
    },
    {
      title: '마감일',
      dataIndex: 'dueDate',
      width: '6%',
      sorter: (a: Task, b: Task) => a.dueDate.localeCompare(b.dueDate),
      render: (text: any, record: any) => (
        <>
          <span
            className="clickable-table-item"
            onClick={() => moveToDetailPage('' + record.id)}
          >
            {moment(record.dueDate).format('YYYY-MM-DD')}
          </span>
        </>
      ),
    },
    {
      title: '',
      key: 'action',
      dataIndex: '',
      align: 'center',
      width: '3%',
      render: (text, record, index) => (
        <Space size="small">
          {record.requester.id === user.id &&
            (record.status === TaskStatus.WORK_REQUEST ||
              record.status === TaskStatus.HOLD) && (
              <div onClick={(e) => e.stopPropagation()}>
                <Popconfirm
                  title="정말 삭제하시겠습니까?"
                  data-test={`project-list-item-${index}`}
                  onConfirm={() => onDelete('' + record.id)}
                >
                  <Button size="small">삭제</Button>
                </Popconfirm>
              </div>
            )}
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Title level={3}>업무 리스트</Title>
        <Button onClick={() => moveToCreatePage()} size="small">
          생성
        </Button>
      </Row>
      {tasks && (
        <Table<Task>
          rowKey="id"
          columns={columns}
          dataSource={tasks}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
        />
      )}
    </StyledDiv>
  );
}

export default TaskListComponent;
